import React from 'react';
import ImpressionSubTable from '../ImpressionsTimeLine';

// =============================================================================
// TransactionImpressionsView (V1 simplified-report path) — thin adapter that
// hands the loader-fetched impressions array off to the (facelifted)
// `<ImpressionSubTable/>` adapter, which renders the shared
// `<ImpressionTimeline/>` primitive. Empty / loading state is owned by the
// primitive — this view no longer needs its own AntD `<Empty/>` wrapper.
// =============================================================================

const TransactionImpressionsView = ({ impressions }) => (
  <ImpressionSubTable impressions={impressions || []} />
);

export default TransactionImpressionsView;
